// extracted by mini-css-extract-plugin
export default {"page__container":"notFoundStyles_page__container__fVIUT"};